import React from 'react'
import {
  AppBar,
  Toolbar,
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Badge,
  Typography,
  Divider,
} from '@mui/material'
import { Bell, Search, Settings, LogOut, User } from 'lucide-react'

export default function Header({ sidebarCollapsed }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  
  const handleLogout = () => {
    // TODO: Implement logout logic
    console.log('Logout clicked')
    setAnchorEl(null)
  }
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  
  const handleClose = () => {
    setAnchorEl(null)
  }
  
  return (
        <AppBar
          position="fixed"
          sx={{
            left: sidebarCollapsed ? '70px' : '280px',
            right: 0,
            height: '70px',
            background: 'linear-gradient(90deg, #ffffff 0%, #E8F0FF 100%)',
            borderBottom: '3px solid',
            borderImage: 'linear-gradient(90deg, #4A5BFF 0%, #00C851 50%, #FFBB33 100%) 1',
            zIndex: 999,
            transition: 'left 0.2s ease-in-out',
            boxShadow: '0 4px 20px rgba(0, 41, 255, 0.12)',
            backdropFilter: 'blur(10px)',
          }}
        >
      <Toolbar sx={{ height: '100%', justifyContent: 'space-between', px: 3 }}>
        {/* Left side - Search */}
        <Box sx={{ flex: 1, maxWidth: '400px' }}>
              <TextField
                placeholder="Search events, orders, or reports..."
                size="small"
                sx={{
                  width: '100%',
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: 'grey.50',
                    borderRadius: '25px',
                    transition: 'all 0.2s ease-in-out',
                    '& fieldset': {
                      border: '1px solid transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'grey.100',
                      '& fieldset': {
                        border: '1px solid',
                        borderColor: 'primary.light',
                      },
                    },
                    '&.Mui-focused': {
                      backgroundColor: 'white',
                      boxShadow: '0 4px 12px rgba(0, 41, 255, 0.1)',
                      '& fieldset': {
                        border: '2px solid',
                        borderColor: 'primary.main',
                      },
                    },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search size={20} color="#4A5568" />
                    </InputAdornment>
                  ),
                }}
              />
        </Box>
        
        {/* Right side - Notifications & User */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              {/* Notifications */}
              <IconButton 
                sx={{ 
                  position: 'relative',
                  backgroundColor: 'grey.100',
                  '&:hover': {
                    backgroundColor: 'primary.light',
                    color: 'white',
                  },
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                <Badge
                  badgeContent={1}
                  color="error"
                  sx={{
                    '& .MuiBadge-badge': {
                      width: 12,
                      height: 12,
                      minWidth: 12,
                      fontSize: '0.75rem',
                      fontWeight: 600,
                      background: 'linear-gradient(135deg, #FF4444 0%, #FF6B6B 100%)',
                    },
                  }}
                >
                  <Bell size={20} />
                </Badge>
              </IconButton>
          
              {/* User Menu */}
              <IconButton
                onClick={handleClick}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  padding: 1,
                  borderRadius: 2,
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    backgroundColor: 'grey.100',
                    transform: 'scale(1.02)',
                  },
                }}
              >
                <Avatar 
                  sx={{ 
                    width: 36, 
                    height: 36, 
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    background: 'linear-gradient(135deg, #0029FF 0%, #4A5BFF 100%)',
                    border: '2px solid white',
                    boxShadow: '0 2px 8px rgba(0, 41, 255, 0.2)',
                  }}
                >
                  JD
                </Avatar>
                {!sidebarCollapsed && (
                  <Box sx={{ textAlign: 'left' }}>
                    <Typography variant="body2" fontWeight="600" color="grey.800">
                      John Doe
                    </Typography>
                    <Typography variant="caption" color="grey.500">
                      john@example.com
                    </Typography>
                  </Box>
                )}
              </IconButton>
          
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              sx: { mt: 1, minWidth: 200 },
            }}
          >
            <MenuItem onClick={handleClose}>
              <ListItemIcon>
                <User size={16} />
              </ListItemIcon>
              <ListItemText>Profile</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <ListItemIcon>
                <Settings size={16} />
              </ListItemIcon>
              <ListItemText>Settings</ListItemText>
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <LogOut size={16} />
              </ListItemIcon>
              <ListItemText>Logout</ListItemText>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  )
}
